import normalizer from '../../services/normalizer'
import objectUtils from '../../utils/object-utils'
import stringUtils from '../../utils/string-utils'
import { routeLeafApi } from '../../services/routeLeafApi'

// Share http client
export const http = routeLeafApi

// Returns the uri context for the resource name (to call the API)
// DO NOT include a leading slash '/'
export function resolveUriContextFromResourceName (resource) {
  switch (resource) {
    // Collection
    case 'myDeliveries': return 'my/routes'
    // Item
    case 'activeDelivery': return 'route'
    case 'providerOrder': return 'provider/order'
    default: return resource
  }
}

// Returns the app model name for the resource name
export function resolveModelFromResourceName (resource) {
  switch (resource) {
    case 'activeDelivery': return 'Route'
    default: return resource
  }
}

// Convenience method for resolving "resource" from a Model object
export function parseResourceNameFromModelObject (modelObj = {}) {
  const modelName = modelObj.model
  return (modelName) ? stringUtils.toCamelCase(modelName) : null
}

// Hydrates an app Model object (optionally, with provided fields)
export function buildModelObject (resource, fields) {
  const resolvedModelName = resolveModelFromResourceName(resource)
  const modelName = stringUtils.toTitleCase(resolvedModelName)
  const Item = normalizer.Model(modelName)
  return (fields) ? new Item(fields) : new Item()
}

// ------------------------------------------------------------------ Sync logic

// Mutates the provided target and returns true if synced, or false if nothing synced
export function syncItem (item, target, replace = false) {
  if (!item || !target) return false

  if (replace) target = item // replace
  else Object.assign(target, item) // merge

  return true
}

// Mutates the provided array and returns the index of the sync (or -1 if nothing synced)
export function syncItemIntoArray (item, target, replace = false) {
  if (!item || !target) return -1

  const itemID = item.id
  const indexInTarget = objectUtils.includesObject(target, 'id', itemID, true)

  if (indexInTarget > -1) {
    if (replace) target[indexInTarget] = item // replace
    else Object.assign(target[indexInTarget], item) // merge
  }

  return indexInTarget
}
